/**
 * Paints a PNG/WebP onto a white background and returns it as a JPEG. Vision
 * models read the transparent pixels of a screenshot as black, so a bill
 * saved with an alpha channel comes back blank. PDFs, JPEGs and anything the
 * browser cannot decode are returned untouched; the server decides then.
 */
export async function flattenTransparentImage(file: File, quality = 0.92): Promise<File> {
	if (file.type !== 'image/png' && file.type !== 'image/webp') return file;
	if (typeof createImageBitmap !== 'function' || typeof document === 'undefined') return file;
	try {
		const bitmap = await createImageBitmap(file);
		const canvas = document.createElement('canvas');
		canvas.width = bitmap.width;
		canvas.height = bitmap.height;
		const context = canvas.getContext('2d');
		if (!context) return file;
		context.fillStyle = '#ffffff';
		context.fillRect(0, 0, canvas.width, canvas.height);
		context.drawImage(bitmap, 0, 0);
		bitmap.close();
		const blob = await new Promise<Blob | null>((resolve) => canvas.toBlob(resolve, 'image/jpeg', quality));
		if (!blob) return file;
		const name = file.name.replace(/\.(png|webp)$/i, '') + '.jpg';
		return new File([blob], name, { type: 'image/jpeg', lastModified: file.lastModified });
	} catch {
		return file;
	}
}
